<div class="unauthorized-wrapper">
  <div class="unauthorized-card text-center">
    <mat-icon class="lock-icon">lock</mat-icon>

    <h1>401 - Unauthorized</h1>
    <h4>You are not authorized to access this page.</h4>

    <button
      mat-raised-button
      class="back-btn mt-3"
      (click)="back()"
    >
      Back
    </button>
  </div>
</div>
